import React, { Component } from 'react'
import queryString from 'query-string'
import { connect } from 'react-redux'

import PatientList from './Components/PatientList'
import { patientService } from '../../../_services/patient.service'

class MessageSearch extends Component {
  constructor(props) {
    super(props)

    this.state = {
      total: 0,
      initLoad: true,
      isLoading: true,
      collection: [],
    }
  }

  componentDidMount() {
    this.loadPatients()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      if (this.state.initLoad && this.state.collection.length > 0) {
        this.setState({ initLoad: false })
      }

      this.loadPatients()
    }
  }

  loadPatients() {
    this.setState({
      isLoading: true
    })
    const queryParams = queryString.parse(this.props.location.search)

    const searchParams = {
      page: queryParams.page || 1,
      lastName: queryParams.lastName || '',
      firstName: queryParams.firstName || '',
      dateOfBirth: queryParams.dateOfBirth || '',
    }

    patientService.retrieve(searchParams)
      .then(response => {
        this.setState({
          isLoading: false,
          total: response.total,
          collection: response.collection.data
        })
      })
  }

  render() {
    return <PatientList
      total={this.state.total}
      initLoad={this.state.initLoad}
      location={this.props.location}
      isLoading={this.state.isLoading}
      collection={this.state.collection}
      selectPatient={patient => {
        this.props.history.push('/messages/view', { patientId: patient.id })
      }}
    />
  }
}

export default connect()(MessageSearch)
